import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "./AuthProvider";
import { useSessionExpiry } from "./SessionExpiryContext";
import { ConsentModal } from "components/authentication/consent/ConsentModal";
export const ConsentGate = ({ element }) => {
  const { authenticated, loading, tosAccepted, ppAccepted } = useAuth();
  const { isShowingDialog } = useSessionExpiry();

  if (loading) {
    return <div></div>;
  }

  if (isShowingDialog) {
    return element;
  }

  if (!authenticated) {
    return <Navigate to="/" />;
  }

  if (!tosAccepted || !ppAccepted) {
    return (
      <>
        {element}
        <ConsentModal />
      </>
    );
  }

  return element;
};
